import api from "./api";
// import TokenService from "./token.service";

export const getBanks = async () => {
    return api.get("/v1/cp/bank-accounts");
}

export const getBankDetails = async (params) => {
    return api.get("/v1/cp/bank-accounts/bank-details", { params });
}

export const getBankDetailsById = async (id) => {
    return api.get("/v1/cp/bank-accounts/get-bank-by-id/" + id);
}

export const getFPXBanks = async () => {
    return api.get("/v1/cp/bank-accounts/fpx-bank-details");
}

export const addBank = async (params) => {
    return api.post("/v1/cp/bank-accounts/otp", params);
}

export const updateBank = async (id, params) => {
    return api.patch("/v1/cp/bank-accounts/otp/" + id, params);
}

export const deleteBank = async (id, otp) => {
    return api.delete("/v1/cp/bank-accounts/otp/" + id, { params: { otp } });
}
